import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { AuthContextProvider } from './context/authContext'
import './index.css';
import './style/fontstyle.css'
import './utils/i18n'; 
import { BrowserRouter } from 'react-router-dom';
import store from './store/Store';
import App from './App';
import ReactQueryProvider from './utils/ReactQeuryProvider';

ReactDOM.createRoot(document.getElementById('root')!).render(

  <BrowserRouter>
    <ReactQueryProvider>
      <Provider store={store}>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </Provider>
    </ReactQueryProvider>
  </BrowserRouter>
);
